import { isBefore, isSameDay } from 'date-fns';
import { BillingType, BillMode } from '~/components/BillClientModal/BillClientModal.types';
import { DiscountModel, DiscountType } from '~/models';
import { ChargeDiscountType } from '~/types/api/billing/submit-charges';
import { utils } from '~/utils';
import { createTimeActivityServiceItem } from './BillClientItem.utils';
import { normalizeEffectiveDate } from './BillingDate/BillingDate.utils';
export var BillClientDisabledReason = /*#__PURE__*/ function(BillClientDisabledReason) {
    BillClientDisabledReason["none"] = "";
    BillClientDisabledReason["issuingInvoice"] = "This one-time service has already been added to a future invoice";
    BillClientDisabledReason["billedMaxCharges"] = "This service was already billed the maximum number of times";
    BillClientDisabledReason["oneTimeManualAlreadyInList"] = "This one-time service has already been included in this invoice";
    BillClientDisabledReason["stageAlreadyInList"] = "This stage of this service has already been included in this invoice";
    BillClientDisabledReason["stageScheduledToBeBilled"] = "This stage of this service has already been added to a future invoice";
    BillClientDisabledReason["stageAlreadyBilled"] = "This stage of this service has already been billed";
    return BillClientDisabledReason;
}({});
export function discountToDTO(discount) {
    if (discount.amount) {
        const amountAsNumber = +discount.amount;
        return amountAsNumber ? {
            type: discount.type === DiscountType.Percent ? ChargeDiscountType.Percentage : ChargeDiscountType.Currency,
            amount: amountAsNumber.toString()
        } : undefined;
    } else {
        return undefined;
    }
}
export function getTotal(quantity, rate, serviceTemplateId, discount) {
    if (!serviceTemplateId || !rate || !quantity) return;
    return utils.calculateFinalPrice(+rate, DiscountModel.make(discount.type, +discount.amount), +quantity);
}
export function getBiCode(mode, issueDate, now) {
    switch(mode){
        case BillMode.Upcoming:
            return 18400;
        case BillMode.FutureDate:
            return 18401;
        case BillMode.Now:
            return isSameDay(issueDate, now) ? 18403 : 18402;
    }
}
export function getIssueDateBeforeRelationshipEffectiveDateWarning(relationshipEffectiveDate, issueDate) {
    const effectiveDate = normalizeEffectiveDate(relationshipEffectiveDate);
    if (effectiveDate && isBefore(issueDate, effectiveDate)) return {
        text: "As the issue date precedes the agreement's effective date, your client will need to manually approve the payment."
    };
    return null;
}
export const handleAddSingleTimeActivity = (param)=>{
    let { itemsControl, timeActivity, fullSelectedService, getValues } = param;
    removeFirstLineItemIfUntouched(itemsControl, getValues);
    itemsControl.append(createTimeActivityServiceItem(fullSelectedService, timeActivity));
};
export const handleAddAllTimeActivities = (param)=>{
    let { itemsControl, timeActivities, fullSelectedService, getValues } = param;
    removeFirstLineItemIfUntouched(itemsControl, getValues);
    timeActivities.forEach((timeActivity)=>{
        itemsControl.append(createTimeActivityServiceItem(fullSelectedService, timeActivity));
    });
};
const removeFirstLineItemIfUntouched = (itemsControl, getValues)=>{
    const { items } = getValues();
    const firstItem = items[0];
    if (items.length !== 1 || !!firstItem.note) return;
    const isUntouchedCharge = firstItem.type === BillingType.Charge && !firstItem.charge.serviceTemplateId;
    const isUntouchedService = firstItem.type === BillingType.Service && !firstItem.service.quantity;
    if (isUntouchedCharge || isUntouchedService) itemsControl.remove(0);
};
export const getUnusedTimeActivities = (items, timeActivities)=>{
    return timeActivities.filter((timeActivity)=>!items.some((item)=>item.type === BillingType.Service && item.timeActivityId === timeActivity.id));
};
